import Icon from './index.vue';

/**
 * 缺少
 * favor active
 * review disabled
 */
export default Icon;
